import {Form, Stack} from "react-bootstrap";
import React, {ReactNode, useEffect, useState} from "react";
import "./Unscramble.css";

function Unscramble() {
  const [phrases, setPhrases] = useState<string[]>([]);

  const [queue, setQueue] = useState<string[]>([]);

  const [answer, setAnswer] = useState<string>('');
  const [dwordList, setDwordList] = useState<string[]>([]);

  const [lastAnswer, setLastAnswer] = useState<string>('');
  const [lastUserInput, setLastUserInput] = useState<string>('');
  const [lastResult, setLastResult] = useState<boolean>(false);

  const [userInput, setUserInput] = useState<string>('');

  function shuffle<T>(array: T[]): T[] {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function next() {
    if (phrases.length === 0) {
      // 아직 업로드된 문장이 없음
      setDwordList([]);
      setAnswer("");
      return;
    }

    let phrase: string;
    if (queue.length === 0) {
      const shuffled = shuffle(phrases);        // 상태는 복사본으로 셔플
      setQueue(shuffled.slice(1));
      phrase = shuffled[0];
    } else {
      phrase = queue[0];
      setQueue(queue.slice(1));
    }

    const dword = phrase.split(" ").sort();
    setDwordList(dword);
    setAnswer(phrase);
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const name = file.name.toLowerCase();
    try {
      if (name.endsWith(".txt")) {
        // 텍스트 파일: 줄 단위로 문장(빈 줄/공백 제거)
        const text = await file.text();
        const lines = text
          .split(/\r?\n/)
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
        if (lines.length === 0) {
          alert("유효한 문장이 없습니다.");
          return;
        }
        const shuffled = shuffle(lines);
        setPhrases(lines);
        // 첫 문제 세팅
        const first = shuffled[0];
        setQueue(shuffled.slice(1));
        setAnswer(first);
        setDwordList(first.split(" ").sort());
        setUserInput("");
      } else if (name.endsWith(".json")) {
        // JSON 파일: ["this is a sentence", "hello world", ...] 형태 가정
        const text = await file.text();
        const raw = JSON.parse(text);
        let list: string[] = [];
        if (Array.isArray(raw)) {
          list = raw.map(String).map((s) => s.trim()).filter(Boolean);
        } else if (raw && typeof raw === "object") {
          // { day1: ["..."], day2: ["..."] } 같은 형태도 지원
          for (const v of Object.values(raw as Record<string, unknown>)) {
            if (Array.isArray(v)) list.push(...v.map(String));
          }
          list = list.map((s) => s.trim()).filter(Boolean);
        }
        if (list.length === 0) {
          alert("JSON에서 문장을 찾지 못했습니다.");
          return;
        }
        const shuffled = shuffle(list);
        setPhrases(list);
        const first = shuffled[0];
        setQueue(shuffled.slice(1));
        setAnswer(first);
        setDwordList(first.split(" ").sort());
        setUserInput("");
      } else {
        alert("텍스트(.txt) 또는 JSON(.json) 파일을 업로드하세요.");
      }
    } catch (err) {
      console.error(err);
      alert("파일을 처리하는 중 오류가 발생했습니다.");
    }
  };

  let wordScrambled: ReactNode[] = [];
  let userUsed = userInput.toLowerCase().split(' ');
  dwordList.forEach((dword) => {
    let used = userUsed.includes(dword.toLowerCase());
    if(used) {
      userUsed.splice(userUsed.indexOf(dword.toLowerCase()), 1);
    }
    wordScrambled.push(
      <span className={'fs-2' + (used ? ' text-success' : '')}>
        {used ? <s>{dword}</s> : dword}
      </span>
    )
  });

  function nextIteration(e: React.KeyboardEvent<HTMLInputElement>) {
    if(e.key !== 'Enter') {
      return;
    }
    e.preventDefault();

    if(answer.toLowerCase() === userInput.toLowerCase()) {
      setLastResult(true);
    }
    else {
      setLastResult(false);
    }

    setLastAnswer(answer);
    setLastUserInput(userInput);
    setUserInput('');
    next();
  }

  useEffect(() => {
    next();
  }, []);

  return (
    <Stack className={'align-items-center'} gap={3}>
      <h1>Unscramble</h1>

      <Form.Group controlId="formFile" className="mb-3">

      </Form.Group>
      <span>
        <Form.Control
            type="file"
            accept=".txt"
            onChange={handleFileChange}
        />
        <a href="https://drive.google.com/file/d/1-SOdjcIQbtGFnOK9AoMYGnRpOJ6vwiSo/view?usp=drive_link">파일 양식 다운로드</a>
      </span>

      <div className={"wordContainer"}>
        {
          wordScrambled.map((word) => {
            return (<p className={"word"}>{word}</p>)
          })
        }

      </div>

        <Form.Control
          type={'text'}
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder={'Type the correct sentence'}
          className={'fs-5 w-75'}
          onKeyUp={nextIteration}
        />

        <Stack className={'align-items-center fs-5'} gap={1}>
          <p className={'fw-bold fs-4'}>Last result</p>
          <p>{lastAnswer}</p>
          <p className={(lastResult ? 'text-success' : 'text-danger')}>{lastUserInput}</p>
        </Stack>
    </Stack>
  );
}

export default Unscramble;
